export default __webpack_public_path__ + "static/media/Head.f9e0b0e2.svg";